import React from 'react';
import { EmptyIllustration } from '@avila-tek/ui/src';

function Empty() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <EmptyIllustration className="w-32 h-32" />
      <span className="text-text-gray text-center">
        No hay datos para la busqueda solicitada
      </span>
    </div>
  );
}

export default Empty;
